<app-header [userName]="userName" (logout)="logout()" (redirectToHomePage)="redirectToHomePage()"></app-header>

<router-outlet></router-outlet>
